import React from 'react';
import { IntegrationsCardPropTypes } from './IntegrationsCard.types';
import InlineSVG from '../InlineSVG';
import RenderButtons from '../RenderButtons';
import RenderBodyCopy from '../RenderBodyCopy';
import NextImage from '../NextImage';

const IntegrationsCard: React.FC<IntegrationsCardPropTypes> = ({
  wrapClassName,
  logo,
  preTitle,
  title,
  subTitle,
  description,
  buttons,
  showDescription = false,
}) => {
  const renderLogo = () => {
    if (!logo) {
      return;
    }
    return (
      <>
        {logo?.contentType === 'image/svg+xml' ? (
          <InlineSVG
            src={logo?.url}
            className='max-h-[9.5rem] max-w-[15rem]'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
        ) : (
          <NextImage
            src={logo?.url}
            alt={logo?.description ?? 'integrations logo'}
            width={logo?.width}
            aspectRatio={logo?.width / logo?.height}
            className='max-h-[9.5rem] max-w-[15rem] [&>img]:w-[revert-layer]!'
          />
        )}
      </>
    );
  };

  return (
    <div
      className={`flex w-full flex-col items-start rounded-3xl bg-background-secondary shadow-[#9f9d9d] drop-shadow-md ${wrapClassName}`}
    >
      <div className='relative flex h-[12rem] w-full items-center gap-[2rem] rounded-t-3xl bg-background-grey-light p-[3rem]'>
        {renderLogo()}
        <div className='flex flex-col justify-center gap-[1.5rem]'>
          <p className='text-[2.4rem] font-medium leading-[2.8rem]'>{title}</p>
          {subTitle && <p className='text-[1.6rem]'>{subTitle}</p>}
        </div>
        {preTitle && (
          <div
            className='absolute right-[1rem] top-[1rem] w-auto rounded-3xl bg-background-grey-dark px-[1rem] py-[0.2rem] text-center text-[1.4rem] font-medium text-body-copy--light '
            style={{
              textShadow:
                'rgb(119 119 119 / 20%) 1px 0px 0px, rgb(128 128 128 / 20%) 0.540302px 0.841471px 0px',
            }}
          >
            {preTitle}
          </div>
        )}
      </div>

      <div className='mx-[3rem] mb-[3rem] flex flex-1 flex-col justify-between'>
        {description && showDescription && (
          <RenderBodyCopy className='mt-[3rem] text-wrap!' bodyCopy={description} />
        )}
        <RenderButtons
          className='flex flex-row items-center gap-[1.6rem] space-y-[unset]'
          items={buttons}
        />
      </div>
    </div>
  );
};

export default IntegrationsCard;
